import { useCallback, useEffect, useState } from "react";
import { useResize } from "../../../../hooks";
import { ItemWidget, WidgetRef } from "../../../../types/widget";
import { useWidgetStore } from "../../../../stores";

const COL = 0;
const ROW = 1;

interface Args {
  conRef: React.RefObject<HTMLDivElement>;
  refs: React.MutableRefObject<WidgetRef[]>;
  widgets: ItemWidget[];
  gapSize: number;
}

const useItemWidgetResize = ({
  conRef,
  refs,
  widgets,
  gapSize,
}: Args): void => {
  const items = useWidgetStore((s) => s.items);

  const [conStatus, setConStatus] = useState<number>(ROW);

  const handle = useCallback(() => {
    if (!conRef.current) return;

    let flexT = 0;
    widgets.forEach((w) => (flexT += w.flex));

    if (conStatus === ROW) {
      for (let i = 0; i < widgets.length; i++) {
        if ((refs.current[i]?.clientWidth || 1000) < widgets[i].minWidth) {
          conRef.current.style.flexFlow = "column";
          setConStatus(COL);
          break;
        }
      }
    } else {
      let res = true;
      for (let i = 0; i < widgets.length; i++) {
        if (
          ((conRef.current.clientWidth - gapSize * (widgets.length - 1)) /
            flexT) *
            widgets[i].flex <
          widgets[i].minWidth
        ) {
          res = false;
          break;
        }
      }
      if (res) {
        conRef.current.style.flexFlow = "row";
        setConStatus(ROW);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs, conRef, conStatus, widgets, gapSize, items]);

  useEffect(() => {
    setTimeout(() => {
      handle();
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useResize(handle);
};

export default useItemWidgetResize;
